// extracted by mini-css-extract-plugin
module.exports = {"top-section":"_2nVrF","topSection":"_2nVrF","holiday-sale-color":"RyvYv","holidaySaleColor":"RyvYv","app-icon":"Ysu2K","appIcon":"Ysu2K"};